import * as React from "react";

export function LoadingSpinner({
  label = "Loading…",
}: {
  label?: string;
}): React.ReactElement {
  return (
    <div className="loading-spinner-container" role="status" aria-live="polite">
      <div className="loading-spinner-ring" />
      <span className="loading-spinner-label">{label}</span>
    </div>
  );
}
